import type { CustomerConsultationSummary } from '@/stores/customerConsultationsHub'
import {
  STRIPE_NOSHOW_FEE_CHECKOUT_PROJECTION_KEY,
  STRIPE_SETTLEMENT_PAYMENT_CHECKOUT_PROJECTION_KEY,
} from '@gh/common/models'
import { resolvePayDueCheckoutKind } from './resolvePayDueCheckoutKind'

export type HubFirestoreWatch = {
  collection: 'consultations'
  consultationId: string
  projectionKey: string
}

/** Checkout projections for unpaid hub pay-due rows (payment can finalize without a consultation write). */
export function resolveConsultationHubFirestoreWatches(args: {
  summaries: CustomerConsultationSummary[]
  activeClinicalConsultationId?: string | null
}): HubFirestoreWatch[] {
  void args.activeClinicalConsultationId
  return args.summaries
    .filter((row) => row.uiStatus === 'payment_due')
    .map((summary) => ({
      collection: 'consultations' as const,
      consultationId: summary.consultationId,
      projectionKey:
        resolvePayDueCheckoutKind(summary) === 'noshow'
          ? STRIPE_NOSHOW_FEE_CHECKOUT_PROJECTION_KEY
          : STRIPE_SETTLEMENT_PAYMENT_CHECKOUT_PROJECTION_KEY,
    }))
}

export function watchKeyForConsultationHubFirestoreWatches(args: {
  summaries: CustomerConsultationSummary[]
  activeClinicalConsultationId?: string | null
}): string {
  return resolveConsultationHubFirestoreWatches(args)
    .map(
      (watch) => `${watch.collection}/${watch.consultationId}/projections/${watch.projectionKey}`,
    )
    .join('|')
}
